export const LOCALES = {
  'de': 'Deutsch',
  'en': 'English',
  'it': 'Italiano'
};
